<template>
  <div class="comp">
    <div class="grid help">
      <el-tooltip class="item" effect="dark" content="Aiuto" placement="top">
        <a href="https://blog.ombrelleria.com/stagioni-e-prezzi/" target="new">
          <unicon name="question-circle" height="24" width="24" fill="#fff" />
        </a>
      </el-tooltip>
    </div>
    <div class="grid seasons comp-inner">
      <div class="grid header">
        <div class="grid sectiontitle"><span @click="show('dashboard')"><unicon name="arrow-left" height="32" width="32" /></span>Stagioni e prezzi</div>
        <div class="grid settings">
          <button @click="show('editgrid')" class="btn" key="modifiy"><unicon name="draggabledots" height="14" width="14" /> Modifica spiaggia</button>
          <transition-group name="slide-fade">
            <button class="btn green" @click="addnewseason = true, editseason = false" v-if="hotel && hotel.seasons && hotel.seasons.length > 0" :disabled="addnewseason" key="add"><unicon name="file-plus-alt" fill="#fff" /> aggiungi stagione</button>
          </transition-group>
          <button @click="openmenu()" class="btn"><i class="fas fa-bars"></i></button>
        </div>
      </div>

      
      <div class="grid seasonlist">

        <!-- {{defaultseason}} -->
        <!-- <p>{{seasons}}</p> -->
      
        <transition-group name="slide-fade" mode="out-in">
        
        <div class="grid list" key="list" v-if="hotel && hotel.seasons && hotel.seasons.length > 0">
          <!-- {{hotel.seasons}} -->
          <div class="grid season flatbox" v-for="(seasons, index) in hotel.seasons" :key="seasons.name" :class="{red: deleteseason && seasonindex === index, active: seasonindex === index}">
            <span class="grid" v-if="deleteseason  && seasonindex === index">Sicuro di voler rimuovere {{seasons.name}} ?</span>
            <span class="name" v-if="!deleteseason">{{seasons.name}}</span>
            <span class="range" v-if="!deleteseason">{{seasons.range.start|toDate}} - {{seasons.range.end|toDate}}</span>
            <div class="grid actions" v-if="!deleteseason">
              <span @click="editseason ? !editseason : (editseason = true, season = seasons), addnewseason = false, season = seasons, seasonindex = index"><unicon name="file-edit-alt" /></span>
              <span @click="editseason = false, addseason = false, deleteseason = true, seasonindex = index"><unicon name="trash" /></span>
            </div>
            <div class="grid actions" v-if="deleteseason && seasonindex === index">
              <span @click="deleteseason = false, seasonindex = null" class="btn secondary light sm">no</span>
              <span @click="removeSeason(index, seasons)" class="btn reddark sm"><unicon name="trash-alt" fill="#fff" /> si, rimuovi</span>
            </div>
          </div>
        </div>
        </transition-group>

        <transition-group name="slide-fade" mode="out-in">
        <div class="grid addseason" key="new" v-if="!hotel.seasons || hotel.seasons.length === 0 || addnewseason">
          <h3 v-if="!hotel.seasons || hotel.seasons.length === 0">Aggiungi la tua prima stagione</h3>
          <div class="spacer lg" v-if="!hotel.seasons || hotel.seasons.length === 0"></div>

          <!-- {{season}} -->

          <div class="grid box">
          <el-form ref="seasonform" :rules="rules" :model="season" status-icon>

            <el-form-item prop="">
              <vc-date-picker
                :columns="$screens({ default: 1, lg: 2 })"
                :is-expanded="$screens({ default: false, lg: true })"
                mode='range'
                color="green"
                is-inline
                :disabled-dates='disabledDates'
                v-model="season.range"
                locale="it-IT"
              />
            </el-form-item>

            <!-- {{season}} -->

            <el-form-item label="Denominazione stagione" prop="name">
              <el-input type="text" v-model="season.name" name="name"></el-input>
            </el-form-item>

            <el-form-item label="Prezzo base ombrellone" prop="baseprice">
              <el-input type="text" v-model="season.baseprice" name="baseprice"></el-input>
            </el-form-item>

            <el-form-item v-for="item in season.items" :key="item.icon" :label="'Prezzo base ' + item.name" prop="">
                <el-input type="text" v-model="item.price" name="price"></el-input>
              </el-form-item>

          </el-form>

          <div class="grid btnlist">
            <button @click="addnewseason = false" class="btn"><unicon name="times" /></button>
            <button type="button" class="btn green block" @click="saveSeason('seasonform')">salva stagione</button>
          </div>

          </div>

          <!-- <div class="spacer sm"></div> -->

          

          <!-- <div class="spacer sm"></div> -->

        </div>


        <div class="grid editseason" key="update" v-if="editseason && !addnewseason">
          
          <div class="grid box">
            <!-- {{season.pricelist}} -->
            <!-- {{disabledDates}} -->
            <!-- <p>{{attributes}}</p> -->

            <el-form ref="seasonform" :rules="rules" :model="season" status-icon>

              <el-form-item prop="range">

                <vc-date-picker
                  :columns="$screens({ default: 1, lg: 2 })"
                  :is-expanded="$screens({ default: false, lg: true })"
                  mode='range'
                  is-inline
                  color="green"
                  highlight="true"
                  v-model="season.range"
                  :disabled-dates='disabledDates'
                  locale="it-IT"
                  :attributes="attributes"
                >
                </vc-date-picker>

              </el-form-item>

              <el-form-item label="Denominazione stagione" prop="name">
                <el-input type="text" v-model="season.name" name="name"></el-input>
              </el-form-item>

<!--               <el-form-item label="Prezzo base ombrellone" prop="baseprice">
                <el-input type="text" v-model="season.baseprice" name="baseprice"></el-input>
              </el-form-item>

              <el-form-item v-for="item in season.items" :key="item.icon" :label="'Prezzo base ' + item.name" prop="">
                <el-input type="text" v-model="item.price" name="price" :min="0"></el-input>
              </el-form-item> -->

            </el-form>

            <!-- <div class="spacer sm"></div> -->

          <div class="grid btnlist three">
            <button @click="editseason = false, seasonindex = null" class="btn"><unicon name="times" /></button>
            <button type="button" class="btn dark block" @click="pricelist.open = true"><unicon fill="#fff" name="clipboard-notes" /> Listino prezzi</button>
            <button type="button" class="btn green block" @click="updateSeasons('seasonform')"><unicon name="save" fill="#fff" /> Salva modifiche</button>
          </div>

          </div>

        </div>
        </transition-group>

      </div>

      <el-dialog
        title=""
        :visible.sync="pricelist.open"
        width="fit-content"
        :show-close="true"
        custom-class="pricelist"
        :destroy-on-close="true"
        @open="season.pricelist === undefined ? season.pricelist = [] : season.pricelist">
        <template slot="title">
          <div class="grid header">
            <div class="title" style="font-size: 20px;">Listino prezzi</div>
          </div>
        </template>
        <Pricelist :season.sync="season" :seasonindex="seasonindex" @savePricelist="savePricelist($event)"></Pricelist>
      </el-dialog>

    </div>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'
import helper from '../Mixins/helper'
import Pricelist from '@/components/micro/Pricelist.vue'
export default {
  name: 'Seasons',
  mixins: [helper],
  props: {
    hotel: Object
  },
  data () {
    return {
      editseason: false,
      addnewseason: false,
      deleteseason: false,
      pricelist: {
        open: false
      },
      selectAttribute: {
        highlight: true,
      },
      defaultseason: {
        name: '',
        range: {
          start: '',
          end: ''
        },
        baseprice: 0,
        items: JSON.parse(JSON.stringify(_.map(this.hotel.items, function (o) {
          o.price = 0
          return o
        }))),
        pricelist: []
      },
      seasonindex: null,
      season: {
        name: '',
        range: {
          start: '',
          end: ''
        },
        baseprice: 0,
        items: JSON.parse(JSON.stringify(this.hotel.items)),
        pricelist: []
      },
      rules: {
        name: [
          { required: true, message: 'prego inserire un nome', trigger: 'blur' }
        ],
        baseprice: [
          { required: true, message: 'prego inserire un prezzo base', trigger: 'blur' }
        ]
      }
    }
  },
  components: {
    Pricelist
  },
  methods: {
    show (section) {
      console.log(section)
      this.$emit('open', section)
    },
    // dayclick (event) {
    //   // var self = this
    //   // if (event.attributes.length <= 1) {
    //   //   console.log(event, self.attributes)
    //   //   // self.attributes[0].dates = {}
    //   //   // self.attributes[0].highlight = false
    //   //   // self.season.range = {
    //   //   //   start: event.attributes.date,
    //   //   //   end: ''
    //   //   // }
    //   // }
    // },
    savePricelist () {
      // console.log(data.seasonindex, this.season)
      // this.season.pricelist = data
      console.log(this.hotel.seasons)
      this.updateSeasons('seasonform')
      this.pricelist.open = false
      // this.season.pricelist = []
      // this.season = this.defaultseason
    },
    saveSeason (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.$store.state.hotels.activehotel.segments.length < 1) {
            console.log('no segments')
            var segment = {
              name: 'default',
              seats: _.map(this.$store.state.ombrelloni.ombrelloni, function (ombrellone) {
                return {
                  ombrid: ombrellone.ombrid,
                  ombrelloneid: ombrellone._id
                }
              }),
              color: '',
              price: this.season.baseprice
            }
            console.log(segment)
            this.$store.dispatch('hotels/addSegment', segment)
          }
          this.$store.dispatch('hotels/addSeason', this.season)
          this.addnewseason = false
          this.season = JSON.parse(JSON.stringify(this.defaultseason))
        } else {
          console.log('error saveSeason')
        }
      })
    },
    updateSeasons (formName) {
      console.log('jou: ', this.hotel.seasons)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$store.dispatch('hotels/updateSeasons', this.hotel.seasons).then(() => {
            this.editseason = false
          })
        } else {
          console.log('error submit!!')
        }
      })
    },
    removeSeason (index, season) {
      var self = this
      console.log('removeSeason1 ', index, season)
      // _.pullAt(this.hotel.seasons, index)
      // console.log(this.hotel.seasons.splice(index, 1))
      this.hotel.seasons.splice(index, 1)
      _.map(this.ombrelloni, function (o) {
        o.seasons.splice(index, 1)
        if (_.isEqual(o.seasons, self.hotel.seasons)) {
          // console.log(o.ombrid + ' is ok')
        } else {
          // console.log(o.ombrid + ' is not ok ', o.seasons)
        }
      })
      this.$store.dispatch('hotels/removeSeason', {index: index, season: season}).then(() => {
        this.deleteseason = false
        this.seasonindex = null
      })
    }
  },
  watch: {

  },
  filters: {
    toDate (date) {
      return moment(date, ['DD.MM.YYYY', ], true).format('DD.MM.YYYY')
    }
  },
  computed: {
    attributes() {
      return [{
        highlight: 'red',
        dates: {
          start: this.season.range.start,
          end: this.season.range.end
        }
      }]
    },
    disabledDates () {
      var self = this
      return _.chain(this.$store.state.hotels.activehotel.seasons).filter(function (s) {
        return s.name !== self.season.name
      }).map(function (value) {
        // console.log(value.range)
        return {
          start: value.range.start,
          end: value.range.end
        }
      }).value()
    },
    ombrelloni () {
      var self = this
      return _.chain(self.$store.state.ombrelloni.ombrelloni).filter(function (o) {
        return o.hotelid === self.$store.state.hotels.activehotel._id
      }).orderBy('ombrid').value()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fade-enter-active {
  transition: opacity .5s;
}
.fade-leave-active {
  transition: opacity 0s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all 0s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
</style>
